import { AxiosInstance } from 'axios'

export function networkLogoApiFactory(api: AxiosInstance) {
  const methods = {
    setLogo(file: File) {
      const formData = new FormData()
      formData.append('file', file)
      return api.put<void>('/api/v1/logo/network-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
  }
  return methods
}
